import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import DownloadPage, { getDefaultPageUI } from "components/pages/DownloadPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @function CaptureDownloadsAccountDDOpen
 * @return {React.Component}
 * @exported true
 * @description A capture component in capture group "Download to QuickBooks".
 */
export default function CaptureDownloadsAccountDDOpen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "accountSelect", "isActive" ], true)
    .submit();
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <DownloadPage ui={ ui } />;
}